import { createSvgIcon } from "@mui/material";

export const FileIcon = createSvgIcon(
  <g>
    <path d="M0 2.5C0 1.11929 1.11929 0 2.5 0H13L20 9V22.5C20 23.8807 18.8807 25 17.5 25H2.5C1.11929 25 0 23.8807 0 22.5V5Z" />
    <path d="M13 0L20 9H13V0Z" fill="#00000044" />
  </g>,
  "File",
);
